module.exports = __webpack_public_path__ + "img/module.5828f7bf.svg";